import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { PriceDisplay } from './ui/PriceDisplay';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="py-14 bg-white relative overflow-hidden" data-id="element-267">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-cream/50 -skew-x-12 -z-10" data-id="element-268"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-269">
        <FadeIn data-id="element-270">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/20 text-gold-600 font-bold tracking-wider text-sm mb-4 uppercase" data-id="element-271">
            Presentamos...
          </span>
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-navy-900 mb-3" data-id="element-272">
            Biblia Visual
          </h2>
          <p className="text-lg md:text-xl text-gray-600 font-heading italic mb-8" data-id="element-273">
            "La Guía Visual Definitiva de las Sagradas Escrituras"
          </p>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-274">
          <div className="relative mx-auto max-w-2xl mb-8" data-id="element-275">
            <div className="aspect-[16/9] bg-gray-100 rounded-2xl shadow-2xl border border-gray-200 flex flex-col items-center justify-center overflow-hidden relative" data-id="element-276">
              <div className="absolute inset-0 bg-gradient-to-tr from-navy-900/10 to-transparent" data-id="element-277"></div>
              <span className="text-6xl mb-4" data-id="element-278">📚</span>
              <h3 className="text-2xl font-bold text-gray-400" data-id="element-279">
                Imagen del producto
              </h3>
              <p className="text-gray-500 text-sm mt-2" data-id="element-280">
                Mockup de alta calidad
              </p>
            </div>

            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 w-full max-w-lg flex justify-center gap-2 md:gap-3 flex-wrap" data-id="element-281">
              <span className="bg-navy text-white text-xs font-bold py-1.5 px-3 rounded-full shadow-lg border border-navy-700" data-id="element-282">
                <strong data-id="element-283">280+</strong> Imágenes HD
              </span>
              <span className="bg-navy text-white text-xs font-bold py-1.5 px-3 rounded-full shadow-lg border border-navy-700" data-id="element-284">
                <strong data-id="element-285">66</strong> Libros Cubiertos
              </span>
              <span className="bg-navy text-white text-xs font-bold py-1.5 px-3 rounded-full shadow-lg border border-navy-700" data-id="element-286">
                <strong data-id="element-287">500+</strong> Páginas
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="max-w-2xl mx-auto mt-10" data-id="element-288">
          <p className="text-base md:text-lg text-gray-800 mb-6 leading-relaxed" data-id="element-289">
            Recorre visualmente los <strong data-id="element-290">66 libros</strong> de la Biblia con
            imágenes paso a paso...{' '}
            <em data-id="element-291">incluso si nunca has puesto un pie en Tierra Santa</em>.
          </p>

          <div className="bg-cream rounded-2xl p-6 md:p-8 border border-gold/30 shadow-xl relative" data-id="element-292">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-red-600 text-white font-bold px-5 py-1 rounded-full text-xs tracking-widest uppercase shadow-lg" data-id="element-293">
              Precio de Oferta
            </div>

            <PriceDisplay amount={9.99} originalAmount={49} size="xl" className="mb-4 mt-3" data-id="element-294" />

            <div className="flex flex-wrap justify-center gap-3 text-sm font-medium text-gray-600 mb-5" data-id="element-295">
              <span className="flex items-center gap-1" data-id="element-296">
                <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-297" /> Pago
                único
              </span>
              <span className="flex items-center gap-1" data-id="element-298">
                <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-299" /> Sin
                suscripciones
              </span>
              <span className="flex items-center gap-1" data-id="element-300">
                <CheckCircleIcon className="w-4 h-4 text-green-600" data-id="element-301" /> Sin
                cargos ocultos
              </span>
            </div>

            <Button fullWidth className="py-4 text-lg md:text-xl mb-3 animate-pulse-slow" data-id="element-302">
              QUIERO MI BIBLIA VISUAL
            </Button>

            <p className="text-sm text-gray-500 font-medium" data-id="element-303">
              Descarga inmediata de todo el paquete
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}